import { DefaultError, useQuery } from '@tanstack/react-query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ISmartlinkBoards } from './types';

export const useGetSmartlinkBoards = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ISmartlinkBoards, DefaultError>({
    queryKey: ['smarlink-boards'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Smartlink/Boards`,
      });

      return responseHandler(response, {
        groupName: 'useGetSmartlinkBoards',
      });
    },
    staleTime: 60 * 60 * 1000,
  });
};
export const useGetSmartlinkDomains = (BoardId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ISmartlinkBoards, DefaultError>({
    queryKey: ['smarlink-domains', BoardId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Smartlink/Domains`,
        params: { BoardId },
      });

      return responseHandler(response, {
        groupName: 'useGetSmartlinkDomains',
      });
    },
    staleTime: 60 * 60 * 1000,
    enabled: !!BoardId.length,
  });
};
